// src/components/NewsletterBox.jsx
import React from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  InputAdornment,
} from '@mui/material';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

const NewsletterBox = () => {
  return (
    <Box sx={{ py: 8, backgroundColor: 'background.paper' }}>
      <Container maxWidth="md">
        <Box
          sx={{
            textAlign: 'center',
            p: { xs: 3, sm: 4 },
          }}
        >
          <Typography variant="h4" component="h2" fontWeight="bold" gutterBottom>
            Join Our Newsletter
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 4 }}>
            Stay up to date with our latest collections, offers, and style tips.
          </Typography>

          <Box
            component="form"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 2,
              maxWidth: '600px',
              mx: 'auto',
            }}
          >
            <TextField
              variant="outlined"
              placeholder="Enter your email address"
              fullWidth
              sx={{
                flexGrow: 1,
                '& .MuiOutlinedInput-root': {
                  borderRadius: { sm: '50px 0 0 50px' },
                  backgroundColor: 'background.default',
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailOutlinedIcon color="action" />
                  </InputAdornment>
                ),
              }}
            />
            <Button
              variant="contained"
              color="secondary"
              size="large"
              sx={{
                py: '15px',
                px: 4,
                width: { xs: '100%', sm: 'auto' },
                borderRadius: { sm: '0 50px 50px 0' },
                boxShadow: 'none',
                '&:hover': {
                  boxShadow: 'none',
                },
              }}
            >
              Subscribe
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default NewsletterBox;
